// tslint:disable
export var ActualType;
(function (ActualType) {
    // Standalone Case
    ActualType[ActualType["StandaloneCase"] = 1] = "StandaloneCase";
    // Workflow
    ActualType[ActualType["Workflow"] = 2] = "Workflow";
    // Workflow Case (sub-case to a Workflow)
    ActualType[ActualType["WorkflowCase"] = 3] = "WorkflowCase";
})(ActualType || (ActualType = {}));
ActualType['STANDALONECASE'] = 1;
ActualType['WORKFLOW'] = 2;
ActualType['WORKFLOWCASE'] = 3;
//# sourceMappingURL=ActualType.js.map